<template>
  <div class="project-manage app-panel blank-h">
    <div class="app-control app-table-control">
      <el-button type="primary" @click="add">新增项目</el-button>
      <div class="right-region">
        <el-input placeholder="请输入名称" v-model="search.name" clearable></el-input>
        <el-cascader
          placeholder="请选择所在地"
          :options="chinaOptions"
          filterable
          :props="props"
          v-model="search.china"
          clearable
        >
        </el-cascader>
        <el-button type="primary" @click="searchParams">搜索</el-button>
        <el-button @click="resetParams">重置</el-button>
      </div>
    </div>
    <el-table :data="datas" v-loading="loading">
      <el-table-column label="名称" prop="attr_data.project_attr_name"></el-table-column>
      <el-table-column label="所在地" prop="position"></el-table-column>
      <el-table-column label="案场地址" prop="attr_data.project_attr_address"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <el-button type="text" @click="manage(row.attr_data.project_id)">管理</el-button>
          <el-button type="text" @click="edit(row.attr_data.project_id)">编辑</el-button>
          <el-button type="text" @click="del(row.attr_data.project_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
  </div>
</template>

<script>
  import CommonService from '@/io/common.js';
  import ProjectService from '@/io/project.js';

  export default {
    name: 'ProjectManage',
    data() {
      return {
        search: {
          name: '',
          china: []
        },
        chinaOptions: [],
        props: {
          value: 'system_area_id',
          children: '_child',
          label: 'system_area_name'
        },
        datas: [],
        loading: false,
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        }
      }
    },
    mounted () {
      this.initChinaOptions().then(() => {
        this.initDatas();
      }).catch(() => {});
    },
    methods: {
      initChinaOptions() {
        if (this.$store.state.china) {
          return new Promise((resolve, reject) => {
            this.chinaOptions = this.$store.state.china;
            resolve();
          });
        } else {
          return CommonService.china().then(res => {
            this.chinaOptions = res.data;
            this.$store.commit('setChina', res.data);
          }).catch(() => {});
        }
      },
      initDatas() {
        this.loading = true;
        ProjectService.listPage(
          this.search.name,
          this.search.china[0] ? this.search.china[0] : '',
          this.search.china[1] ? this.search.china[1] : '',
          this.search.china[2] ? this.search.china[2] : '',
          this.page.currentPage
        ).then(res => {
          let source = res.data;
          if (!source.data.length && this.page.currentPage > 1) {
            this.page.currentPage--;
            this.initDatas();
          } else {
            this.datas = source.data.map(val => {
              val.position = `${val.attr_data.province_area_name || ''} ${val.attr_data.city_area_name || ''} ${val.attr_data.district_area_name || ''}`;
              return val;
            });
            this.page.pageSize = source.per_page;
            this.page.total = source.total;
          }
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      add() {
        this.$router.push({
          path: '/project_manage/new'
        });
      },
      manage(id) {
        this.$router.push({
          path: `/project_manage/${id}`
        });
      },
      edit(id) {
        this.$router.push({
          path: `/project_manage/edit/${id}`
        });
      },
      del(id) {
        this.$confirm(
          '确认删除?',
          '提示',
          {
            type: 'warning'
          }
        ).then(() => {
          return ProjectService.del(id);
        }).then(res => {
          return this.initDatas();
        }).then(res => {
          this.$message.success('删除成功');
        }).catch(() => {});
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search.name = '';
        this.search.china = [];
        this.searchParams();
      }
    },
  }
</script>

<style lang="less" scoped>

</style>